import { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import Layout from '../../components/ui/Layout';
import { SettingsNav } from './Branches';
import { IconLayoutGrid } from '@tabler/icons-react';

export default function Departments() {
  const { orgId, userProfile } = useAuth();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  const resolvedOrgId = orgId || userProfile?.orgId;

  useEffect(() => {
    const load = async () => {
      if (!resolvedOrgId) {
        setLoading(false);
        return;
      }
      try {
        const branchesSnap = await getDocs(
          collection(db, 'organisations', resolvedOrgId, 'branches')
        );
        const allDepts = new Set();
        branchesSnap.docs.forEach(d => {
          const depts = d.data().departments || [];
          depts.forEach(dept => allDepts.add(dept));
        });
        setDepartments([...allDepts].sort());
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    load();
  }, [resolvedOrgId]);

  return (
    <Layout>
      <div style={{ display: 'flex', flex: 1, minHeight: '100vh' }}>
        <SettingsNav active="Departments" />
        <div style={{ flex: 1, padding: 'var(--main-padding)' }}>
          <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 4 }}>Departments</h1>
          <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 24 }}>
            {loading ? 'Loading...' : `${departments.length} department${departments.length !== 1 ? 's' : ''}`}
          </p>

          {loading ? (
            <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', padding: '32px 0', textAlign: 'center' }}>Loading departments...</div>
          ) : departments.length === 0 ? (
            <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '48px 32px', textAlign: 'center' }}>
              <IconLayoutGrid size={32} color="var(--color-text-tertiary)" stroke={1.5} style={{ marginBottom: 12 }} />
              <div style={{ fontSize: 14, fontWeight: 400, color: 'var(--color-text-primary)', marginBottom: 6 }}>No departments yet</div>
              <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)' }}>Departments are added when branches are created</div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {departments.map(d => (
                <div key={d} style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '14px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ fontSize: 14, color: 'var(--color-text-primary)' }}>{d}</div>
                  <button style={{ background: 'transparent', color: 'var(--color-text-secondary)', border: '0.5px solid var(--color-border-medium)', borderRadius: 'var(--radius-md)', padding: '5px 12px', fontSize: 12, cursor: 'pointer' }}>Edit</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}